<template>
  <div class="user-card">
    <div v-if="user" class="user-card__body">
      <div class="media mb-3">
        <span class="user-card__icon icon icon-authorized icon_dark"></span>
        <div class="media-body ml-3">
          <div class="font-weight-bold">{{ user.login }}</div>
          <div class="text-muted line-height-min">{{ getFullName(user) }}</div>
        </div>
      </div>
      <p>
        <strong>{{ $t('personInfo.role') }}:</strong><span class="text-light"> {{ role }}</span>
      </p>
      <p>
        <strong>{{ $t('personInfo.3298') }}:</strong><span class="text-light"> {{ status }}</span>
      </p>
      <p>
        <strong>{{ $t('personInfo.position') }}:</strong><span class="text-light"> {{ user.position }}</span>
      </p>
      <p>
        <strong>{{ $t('personInfo.2790') }}</strong
        ><span class="text-light"> {{ user.department }}</span>
      </p>
      <p>
        <strong>{{ $t('personInfo.phone') }}:</strong><span class="text-light"> {{ user.phone }}</span>
      </p>
    </div>
    <div class="user-card__footer btn-group">
      <router-link :to="{ name: 'user-edit', params: { id: user.id } }" class="btn btn-light text-small">{{
        $t('button.edit')
      }}</router-link>
      <button type="button" class="btn btn-light text-small" @click="logout">
        {{ $t('button.9088') }}
      </button>
    </div>
  </div>
</template>

<script>
import '@/styles/components/user-card.less'
import { fullName } from '@/mixins/full-name.js'
import { userStatusList } from '@/modules/status-list.js'
import { userRights } from '@/mixins/user-rights.js'
import { getRoleTitle } from '@/mixins/get-role-title.js'

export default {
  name: 'UserCard',
  mixins: [fullName, userRights, getRoleTitle],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    role() {
      return this.getRolesTitlesList(this.user.user_roles)
    },
    status() {
      return userStatusList[this.user.status].title
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
